import { ApolloClient } from 'apollo-client'
import { HttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'

const graphqlUri =
  process.env.NODE_ENV === 'production'
    ? '/graphql'
    : 'http://localhost:9000/graphql'

export const client = new ApolloClient({
  link: new HttpLink({ uri: graphqlUri }),
  cache: new InMemoryCache(),
})



// WEBPACK FOOTER //
// ./src/configs/ApolloConfig.js